module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0